import { createFileRoute, redirect } from '@tanstack/react-router';

import { preLoadDefaultProject } from '@/lib/queries/project';

export const Route = createFileRoute('/_root/')({
  loader: async ({ context }) => {
    const project = await preLoadDefaultProject({ context });

    // Check if getting started is complete
    const isGettingStartedComplete = project.installedOnChannel === true;

    // Debug logging
    console.debug('Debug - Index Route Loader:', {
      slackWorkspaceName: project.slackWorkspaceName,
      installedOnChannel: project.installedOnChannel,
      isGettingStartedComplete,
    });

    // If getting started is not complete, redirect to getting started
    if (!isGettingStartedComplete) {
      throw redirect({ to: '/getting-started' });
    } else {
      // If getting started is complete, redirect to RCA
      throw redirect({ to: '/rca' });
    }
  },
});
